import { render, staticRenderFns } from "./RightsShopList.vue?vue&type=template&id=38fd5ff6&scoped=true"
import script from "./RightsShopList.vue?vue&type=script&lang=js"
export * from "./RightsShopList.vue?vue&type=script&lang=js"
import style0 from "./RightsShopList.vue?vue&type=style&index=0&id=38fd5ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd5ff6",
  null
  
)

export default component.exports